module.exports = __webpack_public_path__ + "static/media/61850trans1.0a5c2940.png";